import widgetInfo from './widgetInfoSlice';
import legacyConfigurations from './legacyConfigurationsSlice';
import mapping from './mappingSlice';

const root = {
	widgetInfo,
	legacyConfigurations,
	mapping
};

export default root;
